import { Badge } from '@radix-ui/themes'
import React from 'react'
import { modeColor } from '../../types/DropDownTypes'

interface PillProps {
  label: string
  bgColor?: modeColor
  color?: modeColor
  classNames?: string
}

const Pill: React.FC<PillProps> = ({ color, bgColor, label, classNames }) => {
  return (
    <Badge
      style={
        {
          '--badge-text-light': color!.light?.trim(),
          '--badge-bg-light': bgColor!.light?.trim(),
          '--badge-text-dark': color!.dark?.trim(),
          '--badge-bg-dark': bgColor!.dark?.trim(),
        } as React.CSSProperties
      }
      className={`rounded-2xl border px-3 py-1 text-[var(--badge-text-light)] bg-[var(--badge-bg-light)] dark:text-[var(--badge-text-dark)] dark:bg-[var(--badge-bg-dark)] ${classNames}`}
    >
      {label}
    </Badge>
  )
}

export default Pill
